import { DarkModeOutlined, LightModeOutlined } from '@mui/icons-material';
import { AppBar, Avatar, IconButton, Stack, Toolbar, Typography } from '@mui/material';
import { useGetIdentity } from '@refinedev/core';
import type { RefineThemedLayoutV2HeaderProps } from '@refinedev/mui';
import { HamburgerMenu } from '@refinedev/mui';
import type React from 'react';
import { useContext } from 'react';
import { ColorModeContext } from '../../contexts/color-mode/index.tsx';

type IUser = {
  id: number;
  name: string;
  avatar: string;
};

export const Header: React.FC<RefineThemedLayoutV2HeaderProps> = ({ sticky = false }) => {
  const { mode, toggleMode } = useContext(ColorModeContext);

  const { data: user } = useGetIdentity<IUser>();

  return (
    <AppBar position={sticky ? 'sticky' : 'relative'}>
      <Toolbar>
        <Stack direction="row" width="100%" justifyContent="flex-end" alignItems="center">
          <HamburgerMenu />
          <Stack direction="row" width="100%" justifyContent="flex-end" alignItems="center">
            <IconButton
              color="inherit"
              onClick={() => {
                toggleMode();
              }}
            >
              {mode === 'dark' ? <LightModeOutlined /> : <DarkModeOutlined />}
            </IconButton>

            {(user?.avatar || user?.name) && (
              <Stack direction="row" gap="16px" alignItems="center" justifyContent="center">
                {user?.name && (
                  <Typography
                    sx={{
                      display: {
                        xs: 'none',
                        sm: 'inline-block',
                      },
                    }}
                    variant="subtitle2"
                  >
                    {user?.name}
                  </Typography>
                )}
                <Avatar src={user?.avatar} alt={user?.name} />
              </Stack>
            )}
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
